import { UserEntityModel } from '.';

export class WebinarsEntityModel {
  total: number;
  page: number;
  limit: number;
  list?: (ListEntityModel)[] | null;
}
export class ListEntityModel {
  id: number;
  webinar: WebinarEntityModel;
  user: UserEntityModel;
  employer?: null;
  state: ParticipationState;
  createdAt: string;
  updatedAt: string;
}
export class WebinarEntityModel {
  id: number;
  contents_id: number;
  duration: number;
  live_date: string;
  state: string;
  created_at: string;
  employer: EmployerEntityModel;
  updated_at: string;
  Content: UserEntityModel;
  Sector?: null;
  Employer: Employer1;
}
export class EmployerEntityModel {
  id: string;
  name: string;
  img: string;
  slug: string;
  language: string;
}
export class ContentEntityModel {
  id: number;
  title: string;
  text: string;
  type: string;
  slug: string;
}
export class Employer1 {
  id: string;
  name: string;
  img: string;
  slug: string;
  language: string;
  profile?: null;
}
// export class UserEntityModel {
//   id: string;
//   name: string;
//   surname: string;
//   img: string;
//   phone?: string | null;
//   contact_email?: string | null;
//   contact_address?: string | null;
//   Education: EducationEntityModel;
//   created_at: string;
//   birth_date?: string | null;
//   status: StatusEntityModel;
// }
// export class EducationEntityModel {
//   created_at: string;
//   updated_at: string;
//   Institute: InstituteEntityModel;
//   StudyTag: StudyTagEntityModel;
// }
// export class InstituteEntityModel {
//   id: string;
//   name: string;
// }
// export class StudyTagEntityModel {
//   id: number;
//   tag: string;
//   name_en: string;
//   name_it: string;
//   name_es: string;
//   name_fr: string;
//   created_at: string;
//   updated_at: string;
// }
export class StatusEntityModel {
  value: string;
  updated_at: string;
}

export enum ParticipationState {
  offline = 'viewer',
  participated = 'participated',
  registered = 'not participated'
}